import states from "./States";
import {changeLoginType} from "./Actions";

let loginType = (state = states.loginType, action) => {
    switch (action.type) {
        case changeLoginType.type:
            return action.payload;
        default:
            return state;
    }
}
export {loginType}